__turbopack_context__.v({
  "image": "FileUploadPlaceholder-module-scss-module__h80Pga__image",
  "input": "FileUploadPlaceholder-module-scss-module__h80Pga__input",
});
